import type { SpaceOption } from "@/app/_store/types/dtos";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const preloadSpacesBySize = createAsyncThunk<
  { sizeId: number; spaces: SpaceOption[] },
  number
>("spaces/preloadBySize", async (sizeId: number) => {
  const params = new URLSearchParams({ animalSizeId: String(sizeId) });
  const res = await fetch(`/api/bookings/spaceoptions?${params.toString()}`);
  if (!res.ok) throw new Error(`spaces ${res.status}`);
  const data = await res.json();
  const spaces: SpaceOption[] = Array.isArray(data)
    ? data.map((s: any) => ({
        id: Number(s?.id),
        label: String(s?.label ?? ""),
      }))
    : [];
  return { sizeId, spaces };
});

export const loadAllSpaces = createAsyncThunk<SpaceOption[], number | undefined>(
  "spaces/loadAll",
  async (animalSpeciesId?: number) => {
    const qs =
      animalSpeciesId != null
        ? `?animalSpeciesId=${encodeURIComponent(String(animalSpeciesId))}`
        : "";
    const res = await fetch(`/api/bookings/spaceoptions${qs}`);
    if (!res.ok) throw new Error(`spaces ${res.status}`);
    const data = await res.json();
    const spaces: SpaceOption[] = Array.isArray(data)
      ? data.map((s: any) => ({
          id: Number(s?.id),
          label: String(s?.label ?? ""),
          maxOverall: s?.maxOverall != null ? Number(s.maxOverall) : undefined,
        }))
      : [];
    return spaces;
  }
);
